import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

// Selectors
import { makeSelectQueryStringValue } from 'workspaces/react-router-selectors';

import { MAX_DRAGGABLE_WINDOW_WIDTH_PX } from './constants';
import { OwnProps } from './types';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

const selectEventUuid = (state: any, props: OwnProps) => props.harvestEventUuid;
const selectGroupId = (state: any, props: OwnProps) => props.groupId;

const makeSelectIsOpen = () =>
    createDeepEqualSelector(
        [
            makeSelectQueryStringValue('selectedEvent'),
            makeSelectQueryStringValue('selectedGroup'),
            makeSelectQueryStringValue('eventPopup'),
            selectEventUuid,
            selectGroupId
        ],
        (
            queryStringSelectedEventState,
            queryStringSelectedGroupState,
            queryStringEventPopupState,
            eventUuidProp,
            groupIdProp
        ) => {
            if (!queryStringEventPopupState) {
                return false;
            }

            const harvestEventIsSelected =
                queryStringSelectedEventState === eventUuidProp;
            const groupIsSelected =
                queryStringSelectedGroupState === `${groupIdProp}`;

            return harvestEventIsSelected && groupIsSelected;
        }
    );

const selectIsMobile = () =>
    window.matchMedia(`(max-width: ${MAX_DRAGGABLE_WINDOW_WIDTH_PX}px)`)
        .matches;

export { makeSelectIsOpen, selectIsMobile };
